<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>公告管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.topic" @keyup.enter.native="clicksearch" placeholder="请输入主题" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Topic" label="主题" min-width="15%"></el-table-column>
          <el-table-column prop="Topicsub" label="副主题" min-width="15%"></el-table-column>
          <el-table-column prop="Content" label="内容" min-width="40%"></el-table-column>
          <el-table-column prop="Ishots" label="是否热点" min-width="8%"></el-table-column>
          <el-table-column prop="Isnews" label="是否最新" min-width="8%"></el-table-column>
          <el-table-column label="操作" min-width="14%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="主题" class="addAdminForm">
            <el-input v-model="addData.topic" placeholder="请输入主题"></el-input>
          </el-form-item>
          <el-form-item label="副主题" class="addAdminForm">
            <el-input v-model="addData.topicsub" placeholder="请输入副主题"></el-input>
          </el-form-item>
          <el-form-item label="内容" class="addAdminForm">
            <el-input v-model="addData.content" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="是否热点">
            <el-select v-model="addData.ishot" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否最新">
            <el-select v-model="addData.isnew" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteAnnouncementEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteAnnouncementEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteAnnouncementEdit from '@/componentsKgjt/KgjtWebsiteAnnouncementEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteAnnouncementEdit
  },
  name: 'MyKgjtWebsiteAnnouncement',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      // 查询客户
      keywords: {
        topic: ''
      },
      // 添加
      addData: {
        topic: '',
        topicsub: '',
        content: '',
        ishot: '',
        isnew: ''
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteAnnouncementNum()
    this.GetKgjtWebsiteAnnouncementList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteAnnouncementList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteAnnouncementList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteAnnouncementNum()
      this.GetKgjtWebsiteAnnouncementList()
    },
    clickadd () {
      this.AddKgjtWebsiteAnnouncement()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteAnnouncement(row)
      })
    },
    GetKgjtWebsiteAnnouncementList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        topic: that.keywords.topic
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteAnnouncementList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteAnnouncementNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        topic: that.keywords.topic
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteAnnouncementNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteAnnouncement: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        topic: that.addData.topic,
        topicsub: that.addData.topicsub,
        content: that.addData.content,
        ishot: that.addData.ishot,
        isnew: that.addData.isnew
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteAnnouncement, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.topic = ''
            that.addData.topicsub = ''
            that.addData.content = ''
            that.addData.ishot = ''
            that.addData.isnew = ''

            that.GetKgjtWebsiteAnnouncementNum()
            that.GetKgjtWebsiteAnnouncementList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteAnnouncement: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteAnnouncement, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteAnnouncementNum()
          that.GetKgjtWebsiteAnnouncementList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
